import { Card, CardProps } from 'antd';
import { ReactNode } from 'react';

interface CommonCardProps extends CardProps {
    children: ReactNode;
    noPadding?: boolean;
}

export default function CommonCard({ children, noPadding = false, style, ...props }: CommonCardProps) {
    return (
        <Card
            bordered={false}
            style={{
                borderRadius: '8px',
                boxShadow: '0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12)', // Matches $shadow-card
                marginBottom: '24px',
                overflow: 'hidden',
                ...style,
            }}
            bodyStyle={{
                padding: noPadding ? 0 : '24px',
                ...props.bodyStyle,
            }}
            {...props}
        >
            {children}
        </Card>
    );
}
